<template>
	<div id="app">
		<Loading
			v-if="
				$root.loading &&
					$route.name !== 'SearchGrid' &&
					$route.name !== 'MobileAdvanceSearch'
			"
		></Loading>
		<router-view></router-view>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';

import { debounce } from 'lodash';
import Loading from '@/components/ui/loading';
import Vue from 'vue';
import io from 'socket.io-client';
import getEnv from '@/utils/env';

export default {
	name: 'app',
	components: {
		Loading
	},
	metaInfo() {
		return {
			meta: [
				{
					vmid: 'type',
					property: 'og:type',
					content: 'website'
				},
				{
					vmid: 'url',
					property: 'og:url',
					content: 'https://marketplace.khaosod.co.th/th'
				},
				{
					vmid: 'title',
					property: 'og:title',
					content: `ซื้อ-ขาย สินค้ามือหนึ่งมือสองทุกประเภท | ข่าวสดมาร์เก็ตเพลส`
				},
				{
					vmid: 'description',
					property: 'og:description',
					content: 'ลงประกาศซื้อขายสินค้ากับข่าวสดมาร์เก็ตเพลสฟรี สินค้าหนึ่งมือสอง โทรศัพท์ เครื่องใช้ไฟฟ้า พระเครื่อง รถยนต์ คอนโด บ้าน  ที่ดิน อสังหาริมทรัพย์ทุกชนิดทุกประเภท'
				},
				{
					vmid: 'image',
					property: 'og:image',
					content:
						'https://seukhaistoragepre.blob.core.windows.net/pub-images/img-7923e55343c54a62bdc879e7757b5f4b-800x400.jpg'
				}
			]
		};
	},
	mounted() {
		let isMobile = window.innerWidth <= 768 ? true : false;
		let isTablet = window.innerWidth <= 1200 ? true : false;
		this.$store.commit('UserController/UPDATE_IS_MOBILE', isMobile);
		this.$store.commit('UserController/UPDATE_IS_TABLET', isTablet);
	},
	async created() {
		this.getGoogleClientId();
		this.$root.initSocket();
		window.addEventListener('resize', this.handleWindowResize);
	},
	watch: {
		projectConfig: {
			immediate: true,
			handler(val) {
				if (val) {
					// FAVICON
					const favicon = document.getElementById('favicon-32x32');
					favicon.href = val.favicon_url;
				}
			}
		}
	},
	computed: {
		...mapGetters('ChatController', ['unreadMessages']),
		...mapState('SiteConfigController', ['projectConfig'])
	},
	methods: {
		...mapActions('AdsController', ['GET_GOOGLE_CLIENT_ID_PUBLIC']),
		getGoogleClientId() {
			this.GET_GOOGLE_CLIENT_ID_PUBLIC().then(({ data }) => {
				console.log('getGoogleClientId data', data.google_client_id);
				this.$root.googleClientId = data.google_client_id;
			});
		},
		...mapMutations('ChatController', ['SET_UNREAD_MESSAGE']),

		handleWindowResize: debounce(function() {
			let isMobile = false;
			let isTablet = false;
			if (window.innerWidth <= 768) {
				isMobile = true;
			}
			if (window.innerWidth <= 968) {
				isTablet = true;
			}
			this.$store.commit('UserController/UPDATE_IS_MOBILE', isMobile);
			this.$store.commit('UserController/UPDATE_IS_TABLET', isTablet);
		}, 500)
	}
};
</script>

<style lang="scss" rel="preload">
@import 'assets/scss/style';
// Bootstrap and its default variables
@import '../node_modules/bootstrap/scss/bootstrap';
// BootstrapVue and its default variables
@import '../node_modules/bootstrap-vue/src/index.scss';

/*Google fonts*/
// @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");
// Import Main styles for this application

@import url('https://cdn.metroui.org.ua/v4/css/metro-icons.min.css');

@import 'vue-select/src/scss/vue-select.scss';
</style>
